var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 75,
    viewBox: "0 0 98 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.0899 55.3071H31.9185",
    stroke: "#1429B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38.2217V72.3931",
    stroke: "#1429B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0014 67.5215C21.0169 67.8385 15.1481 65.7873 10.664 61.8114C6.17986 57.8355 3.44082 52.2545 3.03913 46.275C2.63743 40.2956 4.60536 34.3983 8.51738 29.8584C12.4294 25.3184 17.9711 22.5007 23.9443 22.0144C24.2548 22.022 24.561 21.9406 24.8268 21.7798C25.0925 21.6191 25.3068 21.3857 25.4443 21.1072C27.5068 15.1351 31.5539 10.0504 36.9109 6.70051C42.268 3.35065 48.6114 1.93811 54.8837 2.69833C61.156 3.45856 66.9783 6.34564 71.38 10.8783C75.7817 15.411 78.4968 21.3153 79.0729 27.6072C79.1214 27.9383 79.2635 28.2486 79.4824 28.5017C79.7013 28.7548 79.988 28.9401 80.3086 29.0358C84.9589 30.1253 89.0476 32.8836 91.7993 36.7875C94.5509 40.6914 95.7741 45.4695 95.2368 50.2154C94.6995 54.9613 92.4391 59.345 88.8843 62.5349C85.3295 65.7249 80.7276 67.4993 75.9514 67.5215",
    stroke: "#1429B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAdd);
export default __webpack_public_path__ + "static/media/cloud-add.75dff76d2ab8e676e63bf3add27cd8bc.svg";
export { ForwardRef as ReactComponent };